/**
 * Numeric and resource limits shared by the editor, compiler, realtime-api and Playjector.
 * `MacroPackageContracts.h` mirrors every entry; the cross-language contract test
 * compares both against `__fixtures__/contract-tables.json`.
 */
// Raw recordings have no product duration, event-count, or frame-count ceiling. These values
// express only JSON's exact integer domain; available storage and write success govern capture.
const RAW_EXACT_INTEGER_MAX = Number.MAX_SAFE_INTEGER;
export const MACRO_PACKAGE_LIMITS = {
  rawMaxDurationUs: RAW_EXACT_INTEGER_MAX, rawMaxInputEvents: RAW_EXACT_INTEGER_MAX,
  rawMaxFrames: RAW_EXACT_INTEGER_MAX, rawReferenceCatalogMaxJsonBytes: RAW_EXACT_INTEGER_MAX,
  rawMaxRegions: 1_024, rawMaxFramesPerRegionGroup: 64, rawMaxScreenStates: 4_096,
  sourceMaxNodes: 4_096, sourceMaxPackages: 64, sourceMaxEditsPerNode: 10_000,
  compiledMaxNodes: 4_096, compiledMaxEventsPerNode: 10_000, compiledMaxEventsTotal: 200_000,
  compiledMaxNodeDurationMs: 600_000, compiledMaxJsonBytes: 16 * 1024 * 1024, compiledMaxRefPages: 512,
  maxConcurrentSessions: 8, gpuWatchBudget: 256, gpuReferenceSlots: 64, defaultLeaseWaitMs: 2_000,
  keyboardMaxHeld: 6, touchMaxContacts: 10, gamepadSlots: 4, normalizedMax: 65_535,
  expandedEventAssignments: 4_000_000,
  commandStartTimeoutMs: 15_000, commandMarkTimeoutMs: 15_000, commandAbortTimeoutMs: 15_000,
  commandPollTimeoutMs: 10_000, commandFinalizeTimeoutMs: 130_000, hostFinalizeTimeoutMs: 120_000,
} as const;
export type MacroPackageLimitName = keyof typeof MACRO_PACKAGE_LIMITS;
export type MacroPackageLimits = { readonly [Key in MacroPackageLimitName]: number };

export const MACRO_PACKAGE_PERF_BUDGETS = {
  compile10kEventsMs: 200, nativeLoadVerifyMs: 100, inputTimingP99Ms: 4, relativeMouseMaxHz: 250,
} as const;
